import { render, staticRenderFns } from "./Emedica.vue?vue&type=template&id=2cb8b584&scoped=true"
import script from "./Emedica.vue?vue&type=script&lang=js"
export * from "./Emedica.vue?vue&type=script&lang=js"
import style0 from "./Emedica.vue?vue&type=style&index=0&id=2cb8b584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb8b584",
  null
  
)

export default component.exports